var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "connect-overlay", on: { click: _vm.closeConnector } },
    [
      _c(
        "div",
        {
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "input-container",
            {
              ref: "mainInputContainer",
              staticClass: "connector text-center",
              on: { updateValidity: _vm.updateValidity }
            },
            [
              _c(
                "div",
                { staticClass: "w-100 float-right close-btn" },
                [
                  _c("input-button", {
                    staticClass: "mb-2 float-right",
                    attrs: {
                      inputPlaceholder: "x",
                      slimmer: "",
                      variant: "standardInput",
                      btnStyle: "nok-style",
                      smaller: ""
                    },
                    on: { click: _vm.closeConnector }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("h5", [
                _vm._v("\n        Poveži\n        "),
                _c("b", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t(_vm.labelExtension)) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm._l(_vm.getInputFields, function(f) {
                    return _c(
                      "div",
                      { key: f.name, attrs: { id: "container_" + f.name } },
                      [
                        _vm.isMobileView
                          ? _c(
                              "div",
                              {
                                staticClass: "tooltip-popup",
                                attrs: { id: f.name + "_mobile" }
                              },
                              [_vm._v("\n\n            ?\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("input-text", {
                          attrs: {
                            id: f.name + "_desktop",
                            inputName: f.name,
                            inputPlaceholder: _vm.$t(f.placeholder),
                            constraints: _vm.getInputConstraints(f.name),
                            variant: "standardInput",
                            smaller: "",
                            slimmer: ""
                          },
                          on: { fieldUpdate: _vm.fieldUpdate }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-popover",
                          {
                            ref: "popover",
                            refInFor: true,
                            attrs: {
                              target: _vm.getTarget(f.name),
                              placement: _vm.getPlacement,
                              triggers: "hover",
                              container: "container_" + f.name
                            }
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(f.tooltipLabel)) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(f.label)) +
                                  "\n            "
                              )
                            ])
                          ],
                          2
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("input-button", {
                    staticClass: "mt-2",
                    attrs: {
                      inputPlaceholder: _vm.$t("Button.connect"),
                      variant: "standardInput",
                      btnStyle: "ok-style",
                      smaller: "",
                      centered: "",
                      dissabled: !_vm.hasValidInputs
                    },
                    on: { click: _vm.connectChannel }
                  })
                ],
                2
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69aa770e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69aa770e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/connectors/AuthConnector.vue
// module id = null
// module chunks = 